import { render, staticRenderFns } from "./WelcomeIcon.vue?vue&type=template&id=46262de5&"
import script from "./WelcomeIcon.vue?vue&type=script&lang=js&"
export * from "./WelcomeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports